import { createReducer } from 'modules/app-core/redux-utils'
import t from './actionTypes'

// initialState
const initialState = {
  notes: [],
  noteExpand: {},
  dates: {},
  noteMax: 0,
  canPostNote: false,
  postingNote: false,
  loadingNote: '',
  filterStr: '',
  postNote: '',
}

export default createReducer(initialState, {
  [t.LOAD_NOTE_LIST]: (state, payload) =>
    Object.assign({}, state, {
      notes: payload,
      noteExpand: payload.reduce(
        (prev, curr) => ({ ...prev, [curr.Id]: false }),
        {}
      ),
      noteMax: payload.length,
      loadingNote: '',
    }),
  [t.LOAD_NOTE]: (state, props) => {
    const notes = [props.note, ...state.notes]
    return Object.assign({}, state, {
      notes,
      noteMax: notes.length,
    })
  },
  [t.POSTING_NOTE]: (state, payload) =>
    Object.assign({}, state, {
      postingNote: payload,
    }),
  [t.LOADING_NOTE]: (state, payload) =>
    Object.assign({}, state, {
      loadingNote: payload,
    }),
  [t.EXPAND_ALL]: (state, payload) =>
    Object.assign({}, state, {
      noteExpand: state.notes.reduce(
        (prev, curr) => ({ ...prev, [curr.Id]: payload }),
        {}
      ),
    }),
  [t.EXPAND_NOTE]: (state, payload) =>
    Object.assign({}, state, {
      noteExpand: Object.assign({}, state.noteExpand, {
        [payload.id]: payload.bool,
      }),
    }),
  [t.SET_DATE]: (state, payload) =>
    Object.assign({}, state, {
      dates: Object.assign({}, state.dates, {
        [payload.datename]: payload.date,
      }),
    }),
  [t.SET_NOTE_MAX]: (state, payload) =>
    Object.assign({}, state, {
      noteMax: payload,
    }),
  [t.LOAD_POST_NOTE]: (state, payload) =>
    Object.assign({}, state, {
      postNote: payload,
    }),
  [t.VALIDATE_POST_NOTE]: (state, payload) =>
    Object.assign({}, state, {
      errors: payload,
    }),
  [t.CAN_POST_NOTE]: (state, payload) =>
    Object.assign({}, state, {
      canPostNote: payload,
    }),
  [t.CLEAR_POST_NOTE]: (state, payload) =>
    Object.assign({}, state, {
      postNote: payload,
      errors: undefined,
      canPostNote: false,
      postingNote: false,
    }),
  [t.SET_FILTER_STR]: (state, payload) =>
    Object.assign({}, state, {
      filterStr: payload,
    }),
})
